import themeConfig from '@config/theme.config';

const palette = {
  mode: 'light',
  primary: {
    main: themeConfig.primaryColor,
    light: '#818CF8',
    dark: themeConfig.primaryDeep,
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: themeConfig.secondaryColor,
    light: '#94A3B8',
    dark: '#334155',
    contrastText: '#FFFFFF',
  },
  success: { main: themeConfig.successColor },
  warning: { main: themeConfig.warningColor },
  error: { main: themeConfig.errorColor },
  info: { main: themeConfig.infoColor },
  background: {
    default: themeConfig.pageBackground,
    paper: '#FFFFFF',
  },
  text: {
    primary: themeConfig.textPrimary,
    secondary: themeConfig.textSecondary,
    disabled: themeConfig.textMuted,
  },
  divider: themeConfig.borderColor,
  action: {
    hover: 'rgba(15, 23, 42, 0.04)',
    selected: 'rgba(79, 70, 229, 0.08)',
    focus: 'rgba(79, 70, 229, 0.16)',
  },
};

export default palette;
